import React, { useRef } from "react";
import style from "./index.module.scss";
import Footer from "./components/Footer";
import { useFullscreen, useToggle } from "react-use";
import FloatBtn from "./components/FloatBtn";
import classNames from "classnames";

interface ProjectionLayoutProps {
    children: React.ReactNode;
    footer?: boolean;
    floatButtons?: boolean;
}

export default function ProjectionLayoutBase({
    children,
    footer,
    floatButtons
}: ProjectionLayoutProps) {
    const ref = useRef<HTMLDivElement>(null);
    const [isFullscreen, toggleFullScreen] = useToggle(false);
    useFullscreen(ref, isFullscreen, {
        onClose: () => toggleFullScreen(false)
    });
    const [folded, toggleFolded] = useToggle(false);

    return (
        <div className={classNames(style.root, "PopupContainer")} ref={ref}>
            <div className={style.container}>
                <div className={style.main}>{children}</div>

                {footer && (
                    <Footer folded={folded} toggleFolded={toggleFolded} />
                )}
                {floatButtons && (
                    <FloatBtn
                        isFullscreen={isFullscreen}
                        isFolded={folded}
                        toggleFullScreen={toggleFullScreen}
                        toggleFolded={toggleFolded}
                    />
                )}
            </div>
        </div>
    );
}
